import { css } from '@repo/pandacss/styled-system/css';

export default function SummaryTableMobileHead({ className }: { className?: string }) {
  return (
    <tr className={className}>
      <th
        className={css({
          width: '[50%]',
          bgColor: 'neutral.lightest',
          textAlign: 'center',
          borderBottomColor: 'neutral.lighter2',
          borderBottomWidth: 'thin',
          borderBottomStyle: 'solid',
          borderRightColor: 'neutral.lighter2',
          borderRightStyle: 'solid',
          borderRightWidth: 'thin',
          paddingBlockStart: '2',
          paddingBlockEnd: '2',
          '&:first-of-type': {
            paddingLeft: '[1px]',
          },
        })}
      >
        <span className={css({ textStyle: 'accent' })}>Bank</span>
      </th>
      <th
        className={css({
          backgroundColor: 'neutral.white',
          width: '[50%]',
          textAlign: 'center',
          borderBottomWidth: 'thin',
          borderBottomStyle: 'solid',
          borderBottomColor: 'neutral.lighter2',
          paddingBlockStart: '2',
          paddingBlockEnd: '2',
        })}
      >
        <span className={css({ textStyle: 'accent' })}>Details</span>
      </th>
    </tr>
  );
}
